module.exports = __webpack_public_path__ + "assets/img/icon9-menu.4b3a91da.svg";